import {
  CountdownTimerBlock,
  CountDownTimerSettings,
} from 'Event/Marketplace/Block/CountdownTimer'
import {inThreeDays} from 'lib/date-time'

export const createCountdownTimerBlock = (): CountdownTimerBlock => ({
  type: 'CountdownTimer',
  visibility: 'all',
  background: {
    image: '',
    color: '',
    opacity: 0,
  },
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  alignment: {
    vertical: 'center',
    horizontal: 'center',
  },
  border: {
    width: 0,
    color: '#FFFFFF',
    radius: 0,
  },
  countdownTimer: createCountdown(0),
})

const createCountdown = (numCountdowns: number): CountDownTimerSettings => ({
  enabled: true,
  description: '',
  end: inThreeDays(),
  backgroundColor: '#FFFFFF',
  backgroundOpacity: 100,
  textColor: '#000000',
  numberColor: '#000000',
  numberBackgroundColor: '#FFFFFF',
  numberBackgroundOpacity: 0,
  numberBackgroundRadius: 0,
  numberBackgroundWidth: 100,
  numberBackgroundHeight: 100,
  separator: ':',
  labels: {
    days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
  },
  position: numCountdowns,
  font: null,
  fontSize: 16,
})
